import {
  gtb,
  towne,
  fizz,
  hearthHarmony,
  rogueValleyStrawfest,
  synthscape,
  bakersfieldFilmFestival,
} from "./companies";
import { CustomApp } from "./types";

export const companies: [RegExp, CustomApp][] = [
  [/fordevents.live$/, gtb],
  [/towne.live$/, towne],
  [/fizzevents.live$/, fizz],
  [/handh.live$/, hearthHarmony],
  [/strawfest.live$/, rogueValleyStrawfest],
  [/synthscape.live$/, synthscape],
  [/bakersfieldfilm.live$/, bakersfieldFilmFestival],
];
